export default __webpack_public_path__ + "static/media/welcome.10cb5080.png";